export default "__VITE_ASSET__BE9e6HZc__"